
import Vue from 'vue';
// import Vant from 'vant';
import 'vant/lib/index.css';
import { Toast, Swipe, SwipeItem, Popup, Icon, Button, List,Dialog , PasswordInput, NumberKeyboard} from 'vant';
Toast.setDefaultOptions({ duration: 2000 });
Toast.setDefaultOptions('loading', { forbidClick: true, duration: 0, className: 'vanToastUpdate' });

Vue.use(Toast);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Popup);
Vue.use(Icon);
Vue.use(Button);
Vue.use(List);
Vue.use(Dialog);
Vue.use(PasswordInput);
Vue.use(NumberKeyboard);
Vue.prototype.$toast = Toast

// import Mint from 'mint-ui';
// import 'mint-ui/lib/style.css';
// Vue.use(Mint);  


// WEBPACK FOOTER //
// ./src/util/vant.js